


















































































































































import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import {
  OrderStatus,
  DeliveryType,
  PaymentType,
  PaymentStatus,
  RefundTimes,
  OrderItemStatus
} from "../../../types/enum/OrderEnum";
import OrderBase from "../mixins/order-row-base";
import { IOrderDto } from "../../../types/interface/IOrderDto";
import { OrderDto } from "../../../types/impl/OrderDto";
import { State, Getter, Action, Mutation } from "vuex-class";
import {
  updateOrderStatus,
  merchCancelOrder,
  rejectCancelRequest,
  orderAcceptRefunRequest,
  orderOfflinePayRequest,
  refundOrderForCustomer
} from "../../../api/net/order";
import ReasonBottomSheets from "./bottom-sheets.vue";
import OrderDetailModal from "./refund-detail.vue";
import { IOrderItemDto } from "../../../types/interface/IOrderItem";
import store from "../../../store/index";
import SlotModal from "../../menu/components/SlotModal.vue";
import { event } from "../../../libs/utils";
import {
  IPrinttFoodItemSpecification,
  IPrintFoodItem,
  IPrintOrderInfo,
  IPrintOrderItem
} from "../../../types/interface/IOrderPrintDto";
import { toLocalTime, Operatore } from "../../../api/net/util";
import { Month } from "../../../types/enum/TimeEnum";
import { IOrderCancellationRequestDto } from "../../../types/interface/IOrderCancellationRequestDto";
import { orderCancellationRequestDto } from "../../../types/impl/IOrderCancellationRequestDto";

export enum OrderCancalType {
  OrderCancel = "orderCancel",
  OrderReject = "OrderReject",
  RefundCancel = "refundCancel",
  MerchantCancel = "merchantCancel",
  MerchantRefund = "MerchantRefund"
}

@Component({
  components: {
    ReasonBottomSheets,
    SlotModal,
    OrderDetailModal
  }
})
export default class OrderStepStatus extends OrderBase {
  @Prop({ default: OrderDto }) order!: IOrderDto;
  @Prop({ default: [OrderDto] }) orderGroup!: IOrderDto[];
  @Prop({ default: -1 }) index!: number;
  @Prop({ default: OrderDto.orderItems }) orderItems!: IOrderItemDto[];
  @Prop({ default: -1, type: Number })
  merchConfirmationRefundPercentage!: number;
  @Prop({ default: false }) cannotClickConfirm!: boolean;
  @Prop({ default: () => ({ ...orderCancellationRequestDto }) })
  refundOrder?: IOrderCancellationRequestDto;

  @Getter("orderList") orderList!: IOrderDto[];
  @Getter("showLoading") showLoading!: boolean;
  @Getter("isPc") isPc!: boolean;

  showInputModal: boolean = false;
  defaultRefund: number = this.merchConfirmationRefundPercentage;
  isShowEditEstimatedTimeModal: boolean = false;
  delayMinForEstimatedPickupTime: number = 0;
  changeMinsOfPickupTime: number[] = [10, 20, 30, 60];
  showEstimatedPickupTimeWarningModal: boolean = false;
  specialMerchIds: string[] = store.state.specialMerchant;
  isShowOrderDtailModal: boolean = false;

  refreshOrderList(orderId: string, merchId: string) {
    this.$emit("updateOrderList", orderId, merchId);
    // this.$emit("updateFundOrderList", this.order.merchId);
    // this.$emit("updateHistoryOrderList", orderId, merchId);
  }

  isShowRefundButton(orderStatus: OrderStatus): boolean {
    return (
      this.Completed.includes(orderStatus) &&
      !this.order.hasPendingApprovalRefund &&
      this.order.paymentStatus !== PaymentStatus.Pending &&
      this.order.canCancel
    );
  }

  public get isOfflinePay(): boolean {
    return this.order.paymentType === PaymentType.Offline;
  }

  public get isPaid(): boolean {
    return this.order.paymentStatus > PaymentStatus.Pending;
  }

  public get isPickup(): boolean {
    return this.order.deliveryType === DeliveryType.Pickup;
  }

  public get orderStatus(): OrderStatus {
    return this.order.orderStatus || OrderStatus.Pending;
  }

  public get inputValue(): number | string {
    return this.merchConfirmationRefundPercentage;
  }

  public set inputValue(val: number | string) {
    let inputRef = this.$refs.input as Element;

    if (`${val}`.indexOf(".") <= 1) {
      val = `${val}`.substring(0, 4);
    }
    val = `${val}`.substring(0, 5);

    if (val.indexOf(".") > 0 && !isNaN(Number(val))) {
      inputRef.lazyValue = val;
      this.$emit("changeRefundPercentage", val);
      return;
    }

    if (!isNaN(Number(val))) {
      val = Number(val);
      if (val > 100) {
        val = 100;
      }
    } else {
      val = 0;
    }
    inputRef.lazyValue = val;
    this.$emit("changeRefundPercentage", val);
  }

  public get isOpenInBrowser(): boolean {
    if (sessionStorage.getItem("openInBrowser")) {
      return JSON.parse(sessionStorage.getItem("openInBrowser") as string);
    } else {
      return false;
    }
  }

  successFlag: boolean = true;
  async changeOrderStatus(
    orderStatus: OrderStatus,
    rejectReason?: string,
    merchDecideConfirmedPickupTime?: string
  ) {
    let index = this.orderGroup.findIndex(x => {
      return x.id === this.order.id;
    });
    if (this.index === -1 || !this.order.id || index < 0) {
      this.$message.show({
        text: `Can't found order`
      });
      return;
    }
    let { status } = await updateOrderStatus(
      this.order.merchId,
      this.order.id,
      orderStatus,
      rejectReason,
      merchDecideConfirmedPickupTime
    );
    if (status === 200) {
      this.successFlag = true;
      let { id: orderId, merchId } = this.order;
      this.$emit("updateOrderList", orderId, merchId);
      this.$emit("updateHistoryOrderList", orderId, merchId);
      store.commit("handleShowLoading", true);
    } else {
      this.successFlag = false;
      this.$message.show({
        text: `Can't found order`
      });
    }
  }

  async orderAccept() {
    const isShowEditEstimatedTimeModal: boolean =
      this.order.merch.isAsapOnly &&
      this.order.merch.merchDecideConfirmedTime &&
      this.order.deliveryType === DeliveryType.Pickup;

    if (
      this.estimatedPickupTimeEarlierThanCurrentTime &&
      isShowEditEstimatedTimeModal
    ) {
      this.showEstimatedPickupTimeWarningModal = true;
      return;
    }

    if (isShowEditEstimatedTimeModal) {
      this.isShowEditEstimatedTimeModal = true;
      return;
    }

    await this.changeOrderStatus(OrderStatus.Processing);
    if (this.successFlag) {
      this.$message.show({
        text: `Order accepted`
      });
    }
    if (store.state.isPrintEnable) {
      this.printOrder();
    }
  }

  async orderReady() {
    await this.changeOrderStatus(OrderStatus.Ready);
    if (this.successFlag) {
      this.$message.show({
        text: `Order ready`
      });
    }
  }

  orderComplete() {
    this.changeOrderStatus(OrderStatus.Completed);
  }

  orderDelivery() {
    this.changeOrderStatus(OrderStatus.Delivering);
  }

  async orderOfflinePay() {
    let result = await this.$modal.open({
      title: "Warning!",
      message: "Confirming the order is paid.",
      successText: "Confirm"
    });
    if (result) {
      let { status } = await orderOfflinePayRequest(
        this.order.merchId,
        this.order.id
      );
      if (status === 200) {
        this.orderComplete();
      } else {
        this.$message.show({
          text: `Can't found order`
        });
      }
    }
    store.commit("handleShowLoading", false);
  }

  // 接受退款
  async orderAcceptRefun() {
    this.showInputModal = true;
  }

  async confirmRefundForCustomer() {
    if (this.inputValue <= 0) {
      this.$message.show({
        text: `Refund must be more than 0%`
      });
      return;
    }
    let result = await this.$modal.open({
      title: `Refund Order`,
      message: `Are you sure refund ${this.inputValue}%`
    });

    if (result) {
      this.showInputModal = false;
      let { status } = await orderAcceptRefunRequest(
        this.order.merchId,
        this.order.id,
        Number(this.inputValue)
      );
      if (status === 200) {
        this.refreshOrderList(this.order.id, this.order.merchId);
        this.$message.show({
          text: `Complete the refund operation`
        });
        store.commit("handleShowLoading", false);
      } else {
        this.$message.show({
          text: `Can't found order`
        });
        store.commit("handleShowLoading", false);
      }
    }
  }

  closeInputModal() {
    let inputRef = this.$refs.input as Element;
    inputRef.lazyValue = this.defaultRefund;
    this.inputValue = this.defaultRefund;
    this.showInputModal = false;
  }

  showReson: boolean = false;
  reason: string = "";
  cancelType: OrderCancalType = OrderCancalType.OrderCancel;

  openReasonBottomSheets(cancelType: OrderCancalType) {
    this.showReson = true;
    this.cancelType = cancelType;
  }

  // reason modal hook
  async reasonSubmit(data: {
    reason: string;
    selectItems: Array<string>;
    refund: number;
  }) {
    let { reason, selectItems, refund } = data;
    let selectItemsNames: Array<string> = [];
    for (const key in selectItems) {
      this.orderItems.map(x => {
        if (selectItems[key] === x.id) {
          selectItemsNames = [...selectItemsNames, x.name];
        }
      });
    }
    switch (this.cancelType) {
      case OrderCancalType.OrderCancel:
        let result = await this.$modal.open({
          title: `Cancel Item`,
          message: `Item [${selectItemsNames}] will be cancelled due to: ${reason}, are you sure to submit?`
        });
        if (result) {
          this.merchantCancelRequest(this.order.id, reason, selectItems);
        }
        break;
      case OrderCancalType.RefundCancel:
        // 商户删除商品
        this.merchantCancelRequest(this.order.id, reason, selectItems);

        break;
      case OrderCancalType.MerchantCancel:
        // 商户拒绝退款
        this.rejectRefundCancelRequest(this.order.id, reason);
        break;

      case OrderCancalType.OrderReject:
        // 商户拒绝接单
        this.orderReject(reason);
        break;

      case OrderCancalType.MerchantRefund:
        //商户主动退款
        this.merchantRefund(reason, refund, selectItems);
        break;
    }
  }

  // 商户拒绝退款
  async rejectRefundCancelRequest(orderId: string, reason: string) {
    let { status } = await rejectCancelRequest(
      this.order.merchId,
      orderId,
      reason
    );
    store.commit("handleShowLoading", true);
    if (status === 200) {
      this.refreshOrderList(orderId, this.order.merchId);
      this.$message.show({
        text: "Reject refund"
      });
    } else {
      this.$message.show({
        text: `Can't found order`
      });
    }
  }

  // 商户删除商品
  async merchantCancelRequest(
    orderId: string,
    reason: string,
    orderItemIds: string[]
  ) {
    let { status } = await merchCancelOrder(
      this.order.merchId,
      orderId,
      reason,
      orderItemIds
    );
    store.commit("handleShowLoading", true);
    if (status === 200) {
      this.refreshOrderList(orderId, this.order.merchId);
      let cancelItemsNames: Array<string> = [];
      for (const key in orderItemIds) {
        this.orderItems.map(x => {
          if (orderItemIds[key] === x.id) {
            cancelItemsNames = [...cancelItemsNames, x.name];
          }
        });
      }
      this.$message.show({
        text: `item [${cancelItemsNames}] in order [${this.order.serialNumber}] has been cancelled`
      });
    } else {
      this.$message.show({
        text: `Can't found order`
      });
    }
  }

  // 拒单
  async orderReject(rejectReason: string) {
    await this.changeOrderStatus(OrderStatus.Rejected, rejectReason);
    store.commit("handleShowLoading", true);
    if (this.successFlag) {
      this.$message.show({
        text: `Order cancel`
      });
    }
  }

  //商户主动退款
  async merchantRefund(
    reason: string,
    refund: number,
    selectItems: Array<string>
  ) {
    let { status } = await refundOrderForCustomer(
      this.order.merchId,
      this.order.id,
      reason,
      refund,
      selectItems
    );
    if (status === 200) {
      if (this.$route.name === "History") {
        this.$emit("updateHistoryOrderList", this.order.id, this.order.merchId);
      } else {
        this.refreshOrderList(this.order.id, this.order.merchId);
      }
    } else {
      this.$message.show({
        text: `Can't found order`
      });
    }
    store.commit("handleShowLoading", false);

    this.$message.show({
      text: "The order is refunded."
    });
  }

  merchantRefundInComplete() {
    // if (this.isOfflinePay) {
    //   this.$message.show({
    //     text: "The platform did not process the offline payment."
    //   });
    // } else if (this.order.complainTotal === RefundTimes.Twice) {
    //   this.$message.show({
    //     text: "Order cannot be refunded more than two times"
    //   });
    // } else {
    //   this.openReasonBottomSheets(OrderCancalType.MerchantRefund);
    // }

    if (!this.order.canCancel) {
      this.$message.show({
        text: "Order cannot be refunded or cancelled"
      });
    } else {
      this.openReasonBottomSheets(OrderCancalType.MerchantRefund);
    }
  }

  toTracking() {
    const openInBrowser: boolean = Boolean(
      sessionStorage.getItem("openInBrowser")
    );
    if (openInBrowser || this.isPc) {
      window.open(`${this.trackingUrl}&OrderNumber=${this.order.serialNumber}`);
    } else {
      event(
        "toTrackingPage",
        `${this.trackingUrl}&OrderNumber=${this.order.serialNumber}`
      );
    }
  }

  public get trackingUrl(): string {
    return this.order.trackingUrl;
  }

  printOrder() {
    let foodItems: IPrintFoodItem[] = this.order.orderItems
      .filter((item, index) => {
        return item.foodId ? true : false;
      })
      .filter(item => {
        return item.status === OrderItemStatus.Normal;
      })
      .map(item => {
        return {
          foodName: item.name,
          foodQuantity: item.quantity,
          specification: item.params.map(item => {
            return {
              desc: item.name,
              specificationQuantity: item.quantity
            };
          })
        };
      });
    let printedSerialNumberArr: string[] = this.order.serialNumber
      .split("")
      .splice(3);
    for (let i = 0; i < printedSerialNumberArr.length; i++) {
      if (Number(printedSerialNumberArr[i]) * 1 !== 0) {
        printedSerialNumberArr.splice(0, i);
        break;
      }
    }

    const orderInfo: IPrintOrderInfo = {
      serialNumber: `Order: ${printedSerialNumberArr.join("")}`,
      foodItems
    };
    let printOrderArr: Array<IPrintOrderItem> = [];
    let itemsTotalCount: number = orderInfo.foodItems.reduce(
      (totalCount: number, currentItem: IPrintFoodItem) => {
        return totalCount + currentItem.foodQuantity;
      },
      0
    );

    let currentItemIndex: number = 0;
    let orderAcceptTime: string = this.order.turnedProcessingAt
      ? this.order.turnedProcessingAt
      : "";

    if (orderAcceptTime) {
      orderAcceptTime = toLocalTime(orderAcceptTime, Operatore.Horizontal);
    } else {
      orderAcceptTime = toLocalTime(new Date(), Operatore.Horizontal);
    }
    const date: string = orderAcceptTime.split(" ")[0];
    const month: string = Month[Number(date.split("-")[1])];
    const day: string = date.split("-")[2];
    const time: string = orderAcceptTime.split(" ")[1];
    orderAcceptTime = ` ${time}, ${month} ${day}`;

    orderInfo.foodItems.map((foodItem: IPrintFoodItem) => {
      for (let i = 0; i < foodItem.foodQuantity; i++) {
        let printOrderItem: IPrintOrderItem = {
          orderInfo: `${orderInfo.serialNumber} (${currentItemIndex +
            1} of ${itemsTotalCount}). For: ${this.order.user.displayName}`,
          itemName: foodItem.foodName.toString(),
          optionInModifier: (foodItem.specification.reduce(
            (
              finallySpecification: string,
              specificationItem: IPrinttFoodItemSpecification
            ) => {
              let foodItemSpecificationDesc: string = "";
              for (
                let j = 0;
                j < specificationItem.specificationQuantity;
                j++
              ) {
                foodItemSpecificationDesc += ` ${specificationItem.desc},`;
              }
              return finallySpecification + foodItemSpecificationDesc;
            },
            ""
          ) as string)
            .trim()
            .slice(0, -1),
          acceptedTime: orderAcceptTime
        };
        printOrderArr.push(printOrderItem);
        currentItemIndex++;
      }
    });
    event("printOrder", JSON.stringify(printOrderArr));
  }

  public get isEnablePrint(): boolean {
    return !(this.isOpenInBrowser || this.isPc);
  }

  public get isShowPrintBtnForTest(): boolean {
    return (
      this.specialMerchIds.includes(this.order.merchId.toUpperCase()) &&
      (window.location.href.includes("testapi") || window.config.showDev) &&
      !(this.isOpenInBrowser || this.isPc)
    );
  }

  public get isShowPrintBtnForPRD(): boolean {
    return (
      this.specialMerchIds.includes(this.order.merchId.toUpperCase()) &&
      !(this.isOpenInBrowser || this.isPc) &&
      window.location.href.includes("apiwin.yamimeal.com")
    );
  }

  public get isShowPrintAndConfirmBtnforTest(): boolean {
    return window.location.href.includes("testapi") || window.config.showDev;
  }

  public get isShowPrintAndConfirmBtnforPRD(): boolean {
    return window.location.href.includes("apiwin.yamimeal.com");
  }

  public get isShowPrintTextForTest(): boolean {
    return (
      this.specialMerchIds.includes(this.order.merchId.toUpperCase()) &&
      (window.location.href.includes("testapi") || window.config.showDev) &&
      !(this.isOpenInBrowser || this.isPc) &&
      store.state.isPrintEnable
    );
  }

  public get isShowPrintTextForPRD(): boolean {
    const PRDMerchIds: string[] = store.state.specialMerchantOnPRD;
    return (
      this.specialMerchIds.includes(this.order.merchId.toUpperCase()) &&
      !(this.isOpenInBrowser || this.isPc) &&
      window.location.href.includes("apiwin.yamimeal.com") &&
      store.state.isPrintEnable
    );
  }

  public get userExpectedPickupDate(): string {
    if (this.order.userExpectedPickupDate) {
      return toLocalTime(
        `${this.order.userExpectedPickupDate}`,
        Operatore.Horizontal
      );
    } else {
      return "";
    }
  }

  async submitChangeEstimatedPickupTime() {
    this.isShowEditEstimatedTimeModal = false;
    try {
      let newEstimatedPickupTime: string = new Date(
        new Date(
          `${this.userExpectedPickupDate}`.replace(/-/g, "/")
        ).getTime() +
          this.delayMinForEstimatedPickupTime * 60 * 1000
      ).toUTCString();

      await this.changeOrderStatus(
        OrderStatus.Processing,
        "",
        newEstimatedPickupTime
      );
      if (this.successFlag) {
        this.$message.show({
          text: `Order accepted`
        });
        if (store.state.isPrintEnable) {
          this.printOrder();
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      this.confirmEstimatedPickupTime = this.userExpectedPickupDate;
      this.delayMinForEstimatedPickupTime = 0;
    }
  }

  confirmEstimatedPickupTime: string = this.userExpectedPickupDate;

  public get dateOfEstimatedPickupTime(): string {
    const date: string = this.confirmEstimatedPickupTime.split(" ")[0];
    const month: string = Month[Number(date.split("-")[1])];
    const day: string = date.split("-")[2];

    return `${month} ${day}`;
  }

  public get timeOfEstimatedPickupTime(): string {
    return this.confirmEstimatedPickupTime.split(" ")[1];
  }

  public get isShowEstimatedDateInModal(): boolean {
    const today: string = toLocalTime(
      `${new Date()}`,
      Operatore.Horizontal
    ).split(" ")[0];
    const EstimatedPickupDate: string = this.confirmEstimatedPickupTime.split(
      " "
    )[0];

    return EstimatedPickupDate !== today;
  }

  addMinsForEstimatedPickupTime(mins: number) {
    this.delayMinForEstimatedPickupTime += mins;
  }

  closeEditEstimatedPickupTimeModal() {
    this.isShowEditEstimatedTimeModal = false;
    setTimeout(() => {
      //定时器解决弹框没有关闭时间就改变的UI问题
      this.confirmEstimatedPickupTime = this.userExpectedPickupDate;
      this.delayMinForEstimatedPickupTime = 0;
    }, 100);
  }

  increaseMinForEstimatedPickupTime() {
    this.delayMinForEstimatedPickupTime += 5;
  }

  reduceMinForEstimatedPickupTime() {
    if (
      new Date(this.confirmEstimatedPickupTime.replace(/-/g, "/")).getTime() >
      new Date().getTime() + 5 * 60 * 1000
    )
      this.delayMinForEstimatedPickupTime -= 5;
  }

  @Watch("delayMinForEstimatedPickupTime")
  changeDelayMinsOfEstimatedPickupTime() {
    this.confirmEstimatedPickupTime = toLocalTime(
      new Date(
        new Date(
          `${this.userExpectedPickupDate}`.replace(/-/g, "/")
        ).getTime() +
          this.delayMinForEstimatedPickupTime * 60 * 1000
      ).toUTCString(),
      Operatore.Horizontal
    );
  }

  public get estimatedPickupTimeEarlierThanCurrentTime(): boolean {
    return (
      new Date().getTime() >
      new Date(this.confirmEstimatedPickupTime.replace(/-/g, "/")).getTime()
    );
  }

  confirmEstimatedPickupTimeWarning() {
    this.showEstimatedPickupTimeWarningModal = false;
    this.isShowEditEstimatedTimeModal = true;
  }

  showRefundDetail() {
    this.isShowOrderDtailModal = true;
  }

  closeRefundDetail() {
    this.isShowOrderDtailModal = false;
  }

  mounted() {
    store.commit("handleShowLoading", false);
  }
}
